import axios from "axios";
import _ from "lodash";
import axiosRetry from "axios-retry";

axiosRetry(axios, { retries: 3 });

const state = {
  cse_static: [],
  loadingCSEtrainingPreferences: false,
  cse_training_preferences: {},
  csa_static: [],
  fl_static: [],
  flsCsesNames: [],
  modalitiesDescPairs: {},
  selectedFlDesc: "",
  fl_cse_conn_obj: {},
  regions: [],
  downgradeOptions: {},
  dashboardLink: "",
  reccomendations: [],
  actionsHistory: [],
  trainingReccomendations: [],
  trainingActionsHistory: [],
  selectedRecommandationIndex: undefined,
  selectedTrainingRecommandationIndex: undefined,
  selectedCSEidRecList: "",
  selectedCSEidTrainingList: "",
  selectedCSEidWorkforceList: "",
  selectedActionHist: { summary: "" },
  modalities: [],
  modalitiesNamesList: [],
  filteredReviewed: false,
  filterCSEbySelectedModalities: false,
  filterCSEbySelectedPlantSections: true,
  contractStatus: [
    { status: "No Contract", active: true },
    { status: "Contract", active: true },
  ],
  cseStatus: [
    { status: "ACTIVE", active: true },
    { status: "SUSPENDED", active: true },
  ],
  actionsLabels: {
    Implemented: "Implemented",
    Pending: "To be sent to DMG",
    Exported: "Sent to DMG",
  },
  deleteInProgress: false,
  submitUserActionInProgress: false,
  editRecInProgress: false,
};

function getCurrentDate() {
  var m = new Date();
  var dateString =
    m.getUTCFullYear() +
    "/" +
    ("0" + (m.getUTCMonth() + 1)).slice(-2) +
    "/" +
    ("0" + m.getUTCDate()).slice(-2) +
    " " +
    ("0" + m.getUTCHours()).slice(-2) +
    ":" +
    ("0" + m.getUTCMinutes()).slice(-2) +
    ":" +
    ("0" + m.getUTCSeconds()).slice(-2);
  return dateString;
}

const getters = {
  cse_static: (state) => state.cse_static,
  cse_training_preferences: (state) => state.cse_training_preferences,
  loadingCSEtrainingPreferences: (state) => state.loadingCSEtrainingPreferences,
  csa_static: (state) => state.csa_static,
  fl_static: (state) => state.fl_static,
  flsCsesNames: (state) => state.flsCsesNames,
  modalitiesDescPairs: (state) => state.modalitiesDescPairs,
  selectedFlDesc: (state) => state.selectedFlDesc,
  fl_cse_conn_obj: (state) => state.fl_cse_conn_obj,
  regions: (state) => state.regions,
  downgradeOptions: (state) => state.downgradeOptions,
  dashboardLink: (state) => state.dashboardLink,
  reccomendations: (state) => state.reccomendations,
  trainingReccomendations: (state) => state.trainingReccomendations,
  trainingActionsHistory: (state) => state.trainingActionsHistory,
  contractStatus: (state) => state.contractStatus,
  cseStatus: (state) => state.cseStatus,
  actionsHistory: (state) => state.actionsHistory,
  selectedRecommandationIndex: (state) => state.selectedRecommandationIndex,
  selectedTrainingRecommandationIndex: (state) =>
    state.selectedTrainingRecommandationIndex,
  selectedCSEidRecList: (state) => state.selectedCSEidRecList,
  selectedCSEidTrainingList: (state) => state.selectedCSEidTrainingList,
  selectedCSEidWorkforceList: (state) => state.selectedCSEidWorkforceList,
  selectedActionHist: (state) => state.selectedActionHist,
  getFlagName: (state) => (cseAssignment) => {
    console.log(cseAssignment);
    const index =
      state.downgradeOptions.RECOMMENDATION_FL_CSE_ASSIGNMENT_TAGS.findIndex(
        (obj) => {
          return obj.name === cseAssignment;
        }
      );
    if (index != -1) {
      return state.downgradeOptions.RECOMMENDATION_FL_CSE_ASSIGNMENT_TAGS[index]
        .cs_id;
    } else return "";
  },
  getCSEName: (state) => (cseId) => {
    let cseName = "";

    const indexInCSE = state.cse_static.findIndex((obj) => {
      return obj.Id == cseId;
    });
    if (indexInCSE !== -1) {
      cseName = state.cse_static[indexInCSE].Name.replaceAll(",", "");
    } else {
      const indexInCSA = state.csa_static.findIndex((obj) => {
        return obj.Id == cseId;
      });
      if (indexInCSA !== -1) {
        cseName = state.csa_static[indexInCSA].Name.replaceAll(",", "");
      }
    }
    return cseName;
  },
  getActionLabel: (state) => (status) => {
    let label = "";
    label = state.actionsLabels[status];
    return label;
  },
  getFLModality: (state) => (flId) => {
    let modality = "";

    const indexInCSE = state.fl_static.findIndex((obj) => {
      return obj.Id == flId;
    });
    if (indexInCSE !== -1) {
      modality = state.fl_static[indexInCSE].Modality.replaceAll(",", "");
    }
    return modality;
  },
  getFLName: (state) => (flId) => {
    let flName = "";

    const indexInCSE = state.fl_static.findIndex((obj) => {
      return obj.Id == flId;
    });
    if (indexInCSE !== -1) {
      flName = state.fl_static[indexInCSE].Name.replaceAll(",", "");
    }

    return flName;
  },
  getFLCity: (state) => (flId) => {
    let flCity = "";
    const indexInCSE = state.fl_static.findIndex((obj) => {
      return obj.Id == flId;
    });
    if (indexInCSE !== -1) {
      flCity = state.fl_static[indexInCSE].City;
    }
    return flCity;
  },
  getFlDesc: (state) => (flId) => {
    if (flId) {
      // console.log(flId);
      let index = state.fl_static.findIndex((obj) => {
        return obj.Id === flId;
      });
      if (index === -1) return "";
      else {
        return state.fl_static[index].Desc;
      }
    } else return "";
  },
  getReviewDescription: (state) => (status) => {
    let descr = "";

    if (status) {
      if (state.downgradeOptions["RECOMMENDATION_STATE"]) {
        let index = state.downgradeOptions.RECOMMENDATION_STATE.findIndex(
          (obj) => {
            return obj.name === status;
          }
        );
        if (index !== -1) {
          descr =
            state.downgradeOptions.RECOMMENDATION_STATE[index].description;
        }
      }
    }

    // console.log("description: ", descr);
    return descr;
  },

  getModalities: (state) => state.modalities,
  getModalitiesNamesList: (state) => state.modalitiesNamesList,
  // getAllFlsDdescriptions: (state) => {
  //   return JSON.stringify(state.fl_static.map((fl) => fl.Desc));
  // },
  filterCSEbySelectedModalities: (state) => state.filterCSEbySelectedModalities,
  filterCSEbySelectedPlantSections: (state) =>
    state.filterCSEbySelectedPlantSections,
  getActiveModalitiesNames: (state) => {
    let activeModalities = state.modalities
      .filter((el) => {
        return el.active == true;
      })
      .map((el) => {
        return el.Modality;
      });
    return activeModalities;
  },
  getActiveStatusNames: (state) => {
    let activeStatus = state.contractStatus
      .filter((el) => {
        return el.active == true;
      })
      .map((el) => {
        return el.status;
      });
    return activeStatus;
  },
  getActiveRegionsNames: (state) => {
    let activeRegions = state.regions
      .filter((el) => {
        return el.active == true;
      })
      .map((el) => {
        return el.regionName;
      });

    return activeRegions;
  },
  getCSEactiveStatusNames: (state) => {
    let activeCSEstatus = state.cseStatus
      .filter((el) => {
        return el.active == true;
      })
      .map((el) => {
        return el.status;
      });
    return activeCSEstatus;
  },
  filteredReviewed: (state) => state.filteredReviewed,
  filterButtonColor: (state) => {
    if (state.filteredReviewed) return "#EC6602";
    else return "";
  },
  filteredRecommend: (state, getters) => {
    let recFilteredByRegions = state.reccomendations.filter((el) => {
      let index = state.fl_static.findIndex((obj) => {
        return obj.Id === el.new_assignments[0].FLID;
      });

      if (index === -1) return false;
      else {
        if (
          getters.getActiveRegionsNames.indexOf(
            state.fl_static[index].RegionID
          ) !== -1
        ) {
          if (
            getters.getActiveModalitiesNames.indexOf(
              state.fl_static[index].Modality
            ) !== -1
          ) {
            if (
              getters.getActiveStatusNames.indexOf(
                state.fl_static[index].FlContractStatus
              ) !== -1
            ) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        } else return false;
      }
    });

    let recFilteredByStatus = recFilteredByRegions.filter((el) => {
      if (state.filteredReviewed) {
        if (el.status === "Review") return true;
        else return false;
      } else return true;
    });
    return recFilteredByStatus;
  },
  // filteredRecommendGroupedByCSE: (state, getters) => {
  //   const groupedMap = getters.filteredRecommend.reduce((entryMap, e) => {
  //     return entryMap.set(e.new_assignments[0].CSEID, [
  //       ...(entryMap.get(e.new_assignments[0].CSEID) || []),
  //       e,
  //     ]);
  //   }, new Map());
  //   return groupedMap;
  // },
  filteredRecommendGroupedByCSE_recommended: (state, getters) => {
    const groupedMap = getters.filteredRecommend
      .filter((item) => item.type === "recommended_assignment")
      .reduce((entryMap, e) => {
        return entryMap.set(e.new_assignments[0].CSEID, [
          ...(entryMap.get(e.new_assignments[0].CSEID) || []),
          e,
        ]);
      }, new Map());
    return groupedMap;
  },
  filteredTrainingRecommendGroupedByCSE: (state, getters) => {
    const groupedMap = getters.trainingReccomendations.reduce((entryMap, e) => {
      return entryMap.set(e.recommended_training[0].cse_id, [
        ...(entryMap.get(e.recommended_training[0].cse_id) || []),
        e,
      ]);
    }, new Map());
    return groupedMap;
  },
  filteredRecommendGroupedByCSE_installation: (state, getters) => {
    const groupedMap = getters.filteredRecommend
      .filter((item) => item.type === "installation_fl_assignment")
      .reduce((entryMap, e) => {
        return entryMap.set(e.new_assignments[0].CSEID, [
          ...(entryMap.get(e.new_assignments[0].CSEID) || []),
          e,
        ]);
      }, new Map());
    return groupedMap;
  },
  filteredRecommendGroupedByCSE_rbd: (state, getters) => {
    const groupedMap = getters.filteredRecommend
      .filter((item) => item.type === "rbd_compliance_assignment")
      .reduce((entryMap, e) => {
        return entryMap.set(e.new_assignments[0].CSEID, [
          ...(entryMap.get(e.new_assignments[0].CSEID) || []),
          e,
        ]);
      }, new Map());
    return groupedMap;
  },

  actionsGroupedByStatus: (state, getters) => {
    const groupedActionsMap = getters.actionsHistory.reduce((entryMap, e) => {
      return entryMap.set(e.status, [...(entryMap.get(e.status) || []), e]);
    }, new Map());
    return groupedActionsMap;
  },
  filteredModalitiesDecs: (state, getters) => {
    let modalityDesc = state.modalitiesDescPairs;
    let activeModalities = getters.getActiveModalitiesNames;
    let filteredModalities = {};
    for (let key in modalityDesc) {
      if (activeModalities.includes(key)) {
        filteredModalities[key] = modalityDesc[key];
      }
    }
    const flattenedModalities = Array.from(
      Object.entries(filteredModalities)
    ).reduce((acc, [modality, descs]) => {
      descs.forEach((desc) =>
        acc.push({ modality, desc, modalityDesc: modality + " - " + desc })
      );
      return acc;
    }, []);

    return flattenedModalities;
  },
  deleteInProgress: (state) => state.deleteInProgress,
  submitUserActionInProgress: (state) => state.submitUserActionInProgress,
  editRecInProgress: (state) => state.editRecInProgress,
};

const mutations = {
  setCSEs(state, cses) {
    state.cse_static = [...cses];
  },
  setCSAs(state, csas) {
    state.csa_static = [...csas];
  },
  setFLs(state, fls) {
    state.fl_static = [...fls];
  },
  setFlsCsesNames(state) {
    const createUniqueNames = (arr) => {
      const map = new Map();
      arr.forEach((item) => {
        const nameWithoutId = item.Name + (item.City ? " - " + item.City : "");
        const name = item.Id + " - " + nameWithoutId;
        if (
          !map.has(name) &&
          item.RenderLatitude !== "NA" &&
          item.RenderLongitude !== "NA" &&
          !isNaN(item.RenderLatitude) &&
          !isNaN(item.RenderLongitude)
        ) {
          map.set(name, {
            name,
            RenderLatitude: item.RenderLatitude,
            RenderLongitude: item.RenderLongitude,
          });
        }
      });
      return Array.from(map.values());
    };

    const uniqueFlsNames = createUniqueNames(state.fl_static);
    const uniqueCSEsNames = createUniqueNames(state.cse_static);
    const uniqueCSAsNames = createUniqueNames(state.csa_static);

    state.flsCsesNames = [
      ...uniqueFlsNames,
      ...uniqueCSEsNames,
      ...uniqueCSAsNames,
    ];
  },
  setMOdalitiesDesc(state, fls) {
    const pairs = new Map();
    fls.forEach((item) => {
      if (!pairs.has(item.Modality)) {
        pairs.set(item.Modality, []);
      }
      if (!pairs.get(item.Modality).includes(item.Desc)) {
        pairs.get(item.Modality).push(item.Desc);
      }
    });

    // Sort each Desc array in pairs
    for (let [modality, descs] of pairs) {
      pairs.set(modality, descs.sort());
    }

    // Create a new Map from the entries of pairs, sorted by the modality key
    const sortedPairs = new Map([...pairs.entries()].sort());

    state.modalitiesDescPairs = Object.fromEntries(sortedPairs);
  },
  setSelectedFlDesc(state, desc) {
    if (state.selectedFlDesc == desc) state.selectedFlDesc = "";
    else state.selectedFlDesc = desc;
  },
  setConnectionObj(state, conn) {
    state.fl_cse_conn_obj = { ...conn };
  },
  setRegions(state, regs) {
    state.regions = [...regs];
  },
  changeRegionActiveState(state, update) {
    state.regions[update.index].active = update.active; //todo check reactive
  },
  setDowngradeOptions(state, dgOpt) {
    state.downgradeOptions = { ...dgOpt };
  },
  setDashboardLink(state, dashLink) {
    state.dashboardLink = dashLink;
  },
  setReccomendations(state, rec) {
    state.reccomendations = [...rec];
  },
  setActionsHistory(state, act) {
    state.actionsHistory = [...act];
  },
  setTrainingReccomendations(state, rec) {
    state.trainingReccomendations = [...rec];
  },
  setTrainingActionsHistory(state, act) {
    state.trainingActionsHistory = [...act];
  },

  contractReccomendations(state) {
    state.reccomendations.forEach((element, index) => {
      state.reccomendations[index].isExpanded = false;
    });
  },
  contractActionHist(state) {
    state.actionsHistory.forEach((element, index) => {
      state.actionsHistory[index].isExpanded = false;
    });
  },
  contractTrainingReccomendations(state) {
    state.trainingReccomendations.forEach((element, index) => {
      state.trainingReccomendations[index].isExpanded = false;
    });
  },
  changeActionHistExpanded(state, payload) {
    state.actionsHistory[payload.index].isExpanded = payload.val; // todo check reactive
  },
  changeRecommendExpanded(state, payload) {
    state.reccomendations[payload.index].isExpanded = payload.val; // todo check reactive
  },

  changeTrainingIsExpanded(state, payload) {
    state.trainingReccomendations[payload.index].isExpanded = payload.val; // todo check reactive
  },

  setSelectedRecommendationIndex(state, index) {
    state.selectedRecommandationIndex = index;
  },

  setSelectedTrainingRecommendationIndex(state, index) {
    state.selectedTrainingRecommandationIndex = index;
  },

  setSelectedCSEidRecList(state, val) {
    state.selectedCSEidRecList = val;
  },

  setSelectedCSEidTrainingList(state, val) {
    state.selectedCSEidTrainingList = val;
  },

  setSelectedCSEidWorkforceList(state, val) {
    state.selectedCSEidWorkforceList = val;
  },

  setSelectedActionHist(state, index) {
    state.selectedActionHist = _.cloneDeep(state.actionsHistory[index]);
  },
  clearSelectedRecommendationIndex(state) {
    state.selectedRecommandationIndex = undefined;
  },
  clearSelectedTrainingRecommendationIndex(state) {
    state.selectedTrainingRecommandationIndex = undefined;
  },
  clearSelectedActionHist(state) {
    let clearVal = {
      summary: "",
    };
    state.selectedActionHist = { ...clearVal };
  },
  removeRecommendationsAtIndex(state, idx) {
    state.reccomendations.splice(idx, 1);
  },
  removeActionsHistAtIndex(state, idx) {
    state.actionsHistory.splice(idx, 1);
  },

  updateRecAtIndex(state, payload) {
    state.reccomendations[payload.index] = payload.rec; //todo check index
    let recCpy = [...state.reccomendations];
    // recCpy.sort((a, b) => (a.downgraded > b.downgraded ? 1 : -1)); // todo check downgraded no longer exists
    state.reccomendations = [...recCpy];
  },

  updateActAtIndex(state, payload) {
    state.actionsHistory[payload.index] = payload.act;
    let actCpy = [...state.actionsHistory];
    actCpy.sort((a, b) => (Date.parse(a.time) < Date.parse(b.time) ? 1 : -1));
    state.actionsHistory = [...actCpy];
  },

  setModalities(state, mod) {
    state.modalities = [...mod];
  },
  setModalitiesNamesList(state, mod) {
    state.modalitiesNamesList = [...mod];
  },
  setCSEtrainingPreferences(state, payload) {
    state.cse_training_preferences = { ...payload };
  },
  setSingleCSETrainingPreference(state, payload) {
    // Ensure the key exists before updating
    if (
      Object.prototype.hasOwnProperty.call(
        state.cse_training_preferences,
        payload.Id
      )
    ) {
      state.cse_training_preferences[payload.Id] = payload.mod;
    } else {
      console.warn(
        `Id ${payload.Id} does not exist in cse_training_preferences`
      );
    }
  },
  setLoadingCSEtrainingPreferences(state, val) {
    state.loadingCSEtrainingPreferences = val;
  },
  setModalityActiveState(state, payload) {
    state.modalities[payload.index].active = payload.val;
  },
  resetModalities(state) {
    state.modalities = state.modalities.map((el) => {
      return { ...el, active: true };
    });
  },
  uncheckModalities(state) {
    state.modalities = state.modalities.map((el) => {
      return { ...el, active: false };
    });
  },
  setContractStatusActiveState(state, payload) {
    state.contractStatus[payload.index].active = payload.val; //todo check reactive
  },
  setCSEstatusActiveState(state, payload) {
    state.cseStatus[payload.index].active = payload.val;
  },
  toggleFilteredReviewed(state) {
    state.filteredReviewed = !state.filteredReviewed;
  },
  setFilterCSEbySelectedModalities(state, val) {
    // console.log("toggleFilterCSEbySelectedModalities", val);
    state.filterCSEbySelectedModalities = val;
  },
  setFilterCSEbySelectedPlantSections(state, val) {
    state.filterCSEbySelectedPlantSections = val;
  },

  setDeleteProgress(state, val) {
    state.deleteInProgress = val;
  },

  setSubmitUserActionInProgress(state, val) {
    state.submitUserActionInProgress = val;
  },

  setEditRecInProgress(state, val) {
    state.editRecInProgress = val;
  },
};

const actions = {
  async getDowngradeOptions({ rootGetters, commit, dispatch }) {
    try {
      const res = await axios.get(
        rootGetters.backendURL + "/api/recommendation_feedback_options"
      );
      // console.log("******************************** dgrade opts ", res.data);
      commit("setDowngradeOptions", res.data);
    } catch (err) {
      console.log(err);
      commit("setDowngradeOptions", []);
      dispatch("pushNotification", {
        type: "error",
        label: "Get Downgrade Options failed",
        text: "Downgrade Options unavailable",
        duration: "long",
      });
    }
  },
  async getDashboardLink({ rootGetters, commit, dispatch }) {
    try {
      const res = await axios.get(
        rootGetters.backendURL + "/api/external_links"
      );
      // console.log("******************************** dgrade opts ", res.data);
      commit("setDashboardLink", res.data.CSE_dashboard_link);
    } catch (err) {
      console.log(err);
      commit("setDashboardLink", "");
      dispatch("pushNotification", {
        type: "error",
        label: "Get Dashboar dLink failed",
        text: "Dashboard Link unavailable",
        duration: "long",
      });
    }
  },
  async getActionRecommendations({ rootGetters, commit, dispatch }, params) {
    let reqStr = "";
    if (params.selecteddivision == "ImagingZone") {
      reqStr =
        rootGetters.backendURL +
        "/api/service_zone_current_data/action_recommendations_new/" +
        rootGetters.selectedCountry.iso_3166_1 +
        "/" +
        params.area;
    } else {
      reqStr =
        rootGetters.backendURL +
        "/api/service_current_data/action_recommendations_new/" +
        rootGetters.selectedCountry.iso_3166_1 +
        "/" +
        params.area;
    }

    try {
      const res = await axios.get(reqStr);
      // console.log("******************************** dgrade opts ", res.data);
      // context.commit("setDowngradeOptions", res.data);
      let recommend = [];
      let actHist = [];
      let val = res.data.recommendations;
      val.forEach((el) => {
        if (
          el.status === "Implemented" ||
          el.status === "Pending" ||
          el.status === "Exported"
        ) {
          actHist.push({ ...el, isExpanded: false });
        } else {
          recommend.push({
            ...el,
            isExpanded: false,
            // action: "",
            // selectedDowngradeOption: { description: "", id: null, name: "" },
            ...(!el.feedback && { feedback: "" }),
          });
        }
      });

      // sort recommend based on downgraded
      // recommend.sort((a, b) => (a.downgraded > b.downgraded ? 1 : -1));
      actHist.sort((a, b) =>
        Date.parse(a.time) < Date.parse(b.time) ? 1 : -1
      );
      commit("setReccomendations", recommend);
      commit("setActionsHistory", actHist);
    } catch (err) {
      console.log(err);
      // context.commit("setDowngradeOptions", []);
      commit("setReccomendations", []);
      commit("setActionsHistory", []);
      dispatch("pushNotification", {
        type: "warning",
        label: "No Recommendations",
        duration: "long",
        text: "Recommendations unavailable",
      });
    }
  },

  async getTrainingsRecommendations({ rootGetters, commit, dispatch }, params) {
    let reqStr =
      rootGetters.backendURL +
      "/api/service_current_data/training_recommendations/" +
      rootGetters.selectedCountry.iso_3166_1 +
      "/" +
      params.area;

    try {
      const res = await axios.get(reqStr);
      // console.log("******************************** dgrade opts ", res.data);
      // context.commit("setDowngradeOptions", res.data);
      let recommend = [];
      let actHist = [];
      let val = res.data.recommendations;
      val.forEach((el) => {
        if (
          el.status === "Implemented" ||
          el.status === "Pending" ||
          el.status === "Exported"
        ) {
          actHist.push({ ...el, isExpanded: false });
        } else {
          recommend.push({
            ...el,
            isExpanded: false,
            // action: "",
            // selectedDowngradeOption: { description: "", id: null, name: "" },
            ...(!el.feedback && { feedback: "" }),
          });
        }
      });

      // sort recommend based on downgraded
      // recommend.sort((a, b) => (a.downgraded > b.downgraded ? 1 : -1));
      actHist.sort((a, b) =>
        Date.parse(a.time) < Date.parse(b.time) ? 1 : -1
      );
      commit("setTrainingReccomendations", recommend);
      commit("setTrainingActionsHistory", actHist);
    } catch (err) {
      console.log(err);
      // context.commit("setDowngradeOptions", []);
      commit("setTrainingReccomendations", []);
      commit("setTrainingActionsHistory", []);
      dispatch("pushNotification", {
        type: "warning",
        label: "No Training Recommendations",
        duration: "long",
        text: "Training Recommendations unavailable",
      });
    }
  },

  updateRecommendations({ commit, state }, updates) {
    commit("clearSelectedRecommendationIndex");
    commit("contractReccomendations");
    commit("clearSelectedActionHist");
    commit("contractActionHist");

    updates.forEach((resEl) => {
      if (
        resEl.status === "Implemented" ||
        resEl.status === "Pending" ||
        resEl.status === "Exported"
      ) {
        // remove from rec AND add to actionshist
        //don't forget about mapping fields like expanded
        let indexInRec = state.reccomendations.findIndex((object) => {
          return object.uid === resEl.uid;
        });
        if (indexInRec !== -1) {
          //merge with response
          let recCopy = { ...state.reccomendations[indexInRec], ...resEl };

          // add to actionsHist
          //todo check missing fields
          let actHist = [...state.actionsHistory];
          actHist.push({ ...recCopy, isExpanded: false });
          actHist.sort((a, b) =>
            Date.parse(a.time) < Date.parse(b.time) ? 1 : -1
          );
          commit("setActionsHistory", actHist);
          commit("removeRecommendationsAtIndex", indexInRec);
        } else {
          // we have a new user action, we add it to actHist
          //we need to check if UID is already in actHist, if not push to arr
          let actHist = [...state.actionsHistory];
          let index = actHist.findIndex((object) => {
            return object.uid === resEl.uid;
          });
          if (index === -1) {
            actHist.push({ ...resEl, isExpanded: false });
            actHist.sort((a, b) =>
              Date.parse(a.time) < Date.parse(b.time) ? 1 : -1
            );
            commit("setActionsHistory", actHist);
          } else {
            // else update in actHist
            let actCpy = { ...state.actionsHistory[index], ...resEl };
            commit("updateActAtIndex", { index: index, act: actCpy });
          }
        }
      } else {
        // else remove from act hist, if existing and add to rec & sort
        let indexInAct = state.actionsHistory.findIndex((object) => {
          return object.uid === resEl.uid;
        });
        if (indexInAct !== -1) {
          // copy back to rec array
          let actCpy = { ...state.actionsHistory[indexInAct], ...resEl };
          let index = state.reccomendations.findIndex((object) => {
            return object.uid === resEl.uid;
          });
          let currRec = [...state.reccomendations];
          if (index !== -1) {
            let mergedRec = {
              ...state.reccomendations[index],
              ...resEl,
              // action: "",
              isExpanded: false,
              // selectedDowngradeOption: { description: "", id: null, name: "" },
            };
            commit("updateRecAtIndex", { index: index, rec: mergedRec });
          } else {
            //push elem to rec array
            let mergedRec = {
              ...actCpy,
              ...resEl, //todo check
              // action: "",
              isExpanded: false,
              // selectedDowngradeOption: { description: "", id: null, name: "" },
            };
            currRec.push(mergedRec);
            // currRec.sort((a, b) => (a.downgraded > b.downgraded ? 1 : -1));
            commit("setReccomendations", currRec);
          }
          commit("removeActionsHistAtIndex", indexInAct);
        } else {
          //if state is Review/Downgraded and we can't find it in act hist, we must be in the downgrade scenario
          let index = state.reccomendations.findIndex((object) => {
            return object.uid === resEl.uid;
          });
          // let currRec = [...state.reccomendations];
          if (index !== -1) {
            //update existing rec with incoming data
            let mergedRecc = {
              ...state.reccomendations[index],
              ...resEl,
              // action: "",
              isExpanded: false,
              // selectedDowngradeOption: { description: "", id: null, name: "" },
            };
            commit("updateRecAtIndex", { index: index, rec: mergedRecc });
          } //else we have no rec to update
        }
      }
    });
  },

  async resetPendingActionHist({ rootGetters, dispatch, commit }, params) {
    commit("setEditRecInProgress", true);
    let reqStr = "";
    if (params.selecteddivision == "ImagingZone") {
      reqStr =
        rootGetters.backendURL +
        "/api/service_zone_current_data/recommendation_feedback_new/" +
        rootGetters.selectedCountry.iso_3166_1 +
        "/" +
        params.area;
    } else {
      reqStr =
        rootGetters.backendURL +
        "/api/service_current_data/recommendation_feedback_new/" +
        rootGetters.selectedCountry.iso_3166_1 +
        "/" +
        params.area;
    }
    let payload = {
      uid: params.actHist.uid,
      status: params.actHist.status,
      action: "reset",
      // downgraded: params.actHist.downgraded,
      username: rootGetters["oidcStore/oidcUser"].email,
      time: getCurrentDate(),
      new_assignments: params.actHist.new_assignments,
    };
    try {
      const res = await axios.post(reqStr, payload);

      dispatch("updateRecommendations", res.data);
      commit("setEditRecInProgress", false);
    } catch (err) {
      console.log(err);
      commit("setEditRecInProgress", false);
      dispatch("pushNotification", {
        type: "error",
        label: "Reset failed",
        text: "Reset Action failed",
        duration: "long",
      });
    }
  },

  async deletePendingActionHist({ rootGetters, dispatch, commit }, params) {
    // console.log(params);
    commit("setDeleteProgress", true);
    let reqStr = "";
    if (params.selecteddivision == "ImagingZone") {
      reqStr =
        rootGetters.backendURL +
        "/api/service_zone_current_data/recommendation_feedback_new/" +
        rootGetters.selectedCountry.iso_3166_1 +
        "/" +
        params.area;
    } else {
      reqStr =
        rootGetters.backendURL +
        "/api/service_current_data/recommendation_feedback_new/" +
        rootGetters.selectedCountry.iso_3166_1 +
        "/" +
        params.area;
    }
    let payload = {
      uid: params.actHist.uid,
      status: params.actHist.status,
      action: "reset",
      // downgraded: params.actHist.downgraded,
      username: rootGetters["oidcStore/oidcUser"].email,
      time: getCurrentDate(),
      new_assignments: params.actHist.new_assignments,
      is_user_provided_assignment: params.actHist.is_user_provided_assignment,
    };
    console.log(payload);
    try {
      const res = await axios.post(reqStr, payload);
      console.log(res.data);
      commit("clearSelectedActionHist");
      commit("contractActionHist");
      res.data.forEach((resEl) => {
        //remove from act hist

        let indexInAct = state.actionsHistory.findIndex((object) => {
          return object.uid === resEl.uid;
        });
        commit("removeActionsHistAtIndex", indexInAct);
      });
      commit("setDeleteProgress", false);
    } catch (err) {
      console.log(err);
      commit("setDeleteProgress", false);
      dispatch("pushNotification", {
        type: "error",
        label: "Delete failed",
        text: "Delete Action failed",
        duration: "long",
      });
    }
  },
  async exportPendingRecommendation({ getters, dispatch }) {
    let pendingReq = state.actionsHistory.filter((elem) => {
      return elem.status === "Pending" || elem.status === "Exported";
    });

    let pendingReqWithPM = [];
    pendingReq.forEach((element) => {
      pendingReqWithPM.push(element);
      // if (element.mark_primary_as_pm_cse) {
      //   let elemCpy = _.cloneDeep(element);
      //   elemCpy.new_assignments[0].AssignmentType = "pm";
      //   pendingReqWithPM.push(elemCpy);
      // } // todo check if thi is still needed
    });

    // console.log(pendingReqWithPM);

    if (pendingReqWithPM.length) {
      let mappedPend = pendingReqWithPM
        .map((el) => {
          let mapElem = el.new_assignments
            .map((item) => [
              item.FLID,
              getters.getFlagName(item.AssignmentType),
              item.CSEID,
              getters.getCSEName(item.CSEID),
              getters.getFLModality(item.FLID),
              getters.getFLName(item.FLID),
            ])
            .map((e) => e.join(","));

          return mapElem;
        })
        .join("\n");

      mappedPend =
        "FLID,ASSIGNMENT TAG,CSEID,CSE Name,Modality,Facility Name\n" +
        mappedPend;

      // console.log(mappedPend);

      let csvString = "data:text/csv;charset=utf-8," + mappedPend;

      var encodedUri = encodeURI(csvString);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "pending_recommendations.csv");
      document.body.appendChild(link);

      link.click();
    } else {
      dispatch("pushNotification", {
        type: "warning",
        label: "No Recommendations",
        text: "No Pending or Exported recommendations available for download",
      });
    }
  },

  async getCSEsPreferedModalities({ getters, rootGetters, commit }, params) {
    const responses = {};
    commit("setLoadingCSEtrainingPreferences", true);
    for (const item of getters.cse_static) {
      try {
        const res = await axios.get(
          rootGetters.backendURL +
            "/api/cse_training_preference/" +
            params.country +
            "/" +
            params.area +
            "/" +
            item.Id
        );
        responses[item.Id] = res.data.preferred_modalities;
      } catch (err) {
        console.error(`Failed to fetch data for Id ${item.Id}:`, err);
      }
    }
    commit("setCSEtrainingPreferences", responses);
    commit("setLoadingCSEtrainingPreferences", false);
  },

  clickItemCSEMenu({ commit, getters }, params) {
    console.log(getters.reccomendations);
    console.log(params);
    if (params.e.target.label === "Edit") {
      return;
    } else {
      if (params.it.isExpanded) {
        commit("clearSelectedRecommendationIndex");

        let indx = getters.reccomendations.findIndex((obj) => {
          return obj.uid === params.it.uid;
        });
        if (indx !== -1) {
          commit("changeRecommendExpanded", {
            index: indx,
            val: false,
          });
        }
      } else {
        getters.reccomendations.forEach((element, index) => {
          commit("changeRecommendExpanded", {
            index: index,
            val: false,
          });
        });

        let indx = getters.reccomendations.findIndex((obj) => {
          return obj.uid === params.it.uid;
        });

        if (indx !== -1) {
          commit("changeRecommendExpanded", { index: indx, val: true });

          let filteredIndex = getters.filteredRecommend.findIndex((obj) => {
            return obj.uid === params.it.uid;
          });

          if (filteredIndex !== -1) {
            commit("setSelectedRecommendationIndex", filteredIndex);
          }
        }
      }
    }
  },

  clickItemTrainingMenu({ getters, commit }, params) {
    console.log(getters.trainingReccomendations, params);
    //todo
    if (params.e.target.label === "Edit") {
      return;
    } else {
      if (params.it.isExpanded) {
        commit("clearSelectedTrainingRecommendationIndex");

        let indx = getters.trainingReccomendations.findIndex((obj) => {
          return obj.uid === params.it.uid;
        });
        if (indx !== -1) {
          commit("changeTrainingIsExpanded", {
            index: indx,
            val: false,
          });
        }
      } else {
        getters.trainingReccomendations.forEach((element, index) => {
          commit("changeTrainingIsExpanded", {
            index: index,
            val: false,
          });
        });

        let indx = getters.trainingReccomendations.findIndex((obj) => {
          return obj.uid === params.it.uid;
        });

        if (indx !== -1) {
          commit("changeTrainingIsExpanded", { index: indx, val: true });

          let filteredIndex = getters.trainingReccomendations.findIndex(
            (obj) => {
              return obj.uid === params.it.uid;
            }
          );

          if (filteredIndex !== -1) {
            commit("setSelectedTrainingRecommendationIndex", filteredIndex);
          }
        }
      }
    }
  },

  clickCSEName({ commit, getters }, params) {
    console.log(getters.reccomendations);
    console.log(params);
    if (params.e.target.__size !== "header-1") {
      return;
    } else {
      let cseId = params.elem[0];
      if (cseId) {
        if (getters.selectedCSEidRecList == cseId) {
          commit("setSelectedCSEidRecList", "");
        } else {
          commit("setSelectedCSEidRecList", cseId);
        }
        commit("clearSelectedRecommendationIndex");
        getters.reccomendations.forEach((element, index) => {
          commit("changeRecommendExpanded", {
            index: index,
            val: false,
          });
        });
      }
    }
  },

  clickCSENameTraining(params) {
    console.log(params);
    //todo
  },

  clickCSENameWorkforce({ commit, getters }, params) {
    console.log(params);
    if (params.e.target.__size !== "header-1") {
      return;
    } else {
      let cseId = params.elem.Id;
      if (cseId) {
        if (getters.selectedCSEidWorkforceList == cseId) {
          commit("setSelectedCSEidWorkforceList", "");
        } else {
          commit("setSelectedCSEidWorkforceList", cseId);
        }
        // commit("clearSelectedRecommendationIndex");
        // getters.reccomendations.forEach((element, index) => {
        //   commit("changeRecommendExpanded", {
        //     index: index,
        //     val: false,
        //   });
        // });
      }
    }
  },

  clickActionsHistMenu({ commit }, item) {
    if (item.isExpanded) {
      commit("clearSelectedActionHist");
      // this.selectedActionHist = { summary: "" };
      // item.isExpanded = false;

      let indx = state.actionsHistory.findIndex((obj) => {
        return obj.uid === item.uid;
      });
      if (indx !== -1) {
        commit("changeActionHistExpanded", { index: indx, val: false });
      }
    } else {
      state.actionsHistory.forEach((element, index) => {
        commit("changeActionHistExpanded", {
          index: index,
          val: false,
        });
      });

      // item.isExpanded = true;
      let indx = state.actionsHistory.findIndex((obj) => {
        return obj.uid === item.uid;
      });
      if (indx !== -1) {
        commit("changeActionHistExpanded", { index: indx, val: true });

        commit("setSelectedActionHist", indx);
      }
    }
  },

  //select and deselect clicked modalities
  async clickModalityWf({ commit, rootGetters, getters }, params) {
    console.log(params.modality, params.cse, params.e);
    // params.e.target.__active
    if (
      Object.prototype.hasOwnProperty.call(
        getters.cse_training_preferences,
        params.cse.Id
      )
    ) {
      let newVal = [...getters.cse_training_preferences[params.cse.Id]];
      let index = newVal.indexOf(params.modality);
      if (index !== -1) {
        newVal.splice(index, 1);
      } else {
        newVal.push(params.modality);
      }
      try {
        const res = await axios.post(
          rootGetters.backendURL +
            "/api/cse_training_preference/" +
            params.country +
            "/" +
            params.area +
            "/" +
            params.cse.Id,
          {
            preferred_modalities: newVal,
            username: rootGetters["oidcStore/oidcUser"].email,
          }
        );

        commit("setSingleCSETrainingPreference", {
          Id: params.cse.Id,
          mod: res.data.preferred_modalities,
        });
      } catch (err) {
        console.error(
          `Failed to update CSE training preferences for Id ${params.cse.Id}:`,
          err
        );
      }
    }
  },

  clearCockpitState({ commit }) {
    commit("setCSEs", []);
    commit("setFLs", []);
    commit("setRegions", []);
    commit("setDowngradeOptions", []);
    commit("setReccomendations", []);
    commit("setActionsHistory", []);
    commit("setSelectedRecommendationIndex", undefined);
    commit("setSelectedActionHist", { summary: "" });
    commit("setModalities", []);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
